import { ProductType, LocationType, selectLocationType } from 'features/searchResultsFacets';
import { store } from '@redux/store';

import HomesTab from '../components/resultTabs/homesTab';
import CommunitiesTab from '../components/resultTabs/communitiesTab';
import BuildersTab from '../components/resultTabs/buildersTab';
import BuildOnYourLotLocationsTab from '../components/resultTabs/buildOnYourLotLocationsTab';
import CustomHomesTab from '../components/resultTabs/customHomesTab';

const communitiesTab = new CommunitiesTab();
const homesTab = new HomesTab();

const defaultTabs = [communitiesTab, homesTab, new BuildersTab()];
const stateTabs = [communitiesTab, homesTab];
const customAndBuildOnYourLotTabs = [
  new CustomHomesTab(),
  new BuildOnYourLotLocationsTab(),
];

const tabConfiguration = {
  [LocationType.State.toString()]: {
    [ProductType.AllProducts.toString()]: stateTabs,
    [ProductType.Communities.toString()]: stateTabs,
    [ProductType.Homes.toString()]: stateTabs,
  },

  default: {
    [ProductType.AllProducts.toString()]: defaultTabs,
    [ProductType.Communities.toString()]: defaultTabs,
    [ProductType.Homes.toString()]: defaultTabs,
    [ProductType.Custom.toString()]: customAndBuildOnYourLotTabs,
    [ProductType.BuildOnYourLot.toString()]: customAndBuildOnYourLotTabs,
  },
};

/**
 * getResultTabConfiguration: Gets configuration for the tabs to be used according to
 * the product type and location context.
 * @param {string} productTypeName The name of the product type.
 * @returns {Array} The tabs configuration.
 */
function getResultTabConfiguration(productTypeName) {
  const state = store.getState();
  const locationType = selectLocationType(state)?.toString();

  return (
    tabConfiguration[locationType]?.[productTypeName] ??
    tabConfiguration.default[productTypeName] ??
    []
  );
}

export default getResultTabConfiguration;